import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

// Hook to control the deadline modal state and content
export function useDeadlineModal() {
    const [isOpen, setIsOpen] = useState(false);
    const [event, setEvent] = useState(null);

    const openModalForEvent = useCallback((evt) => {
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
        setEvent(null);
    }, []);

    return {
        isOpen,
        event,
        openModalForEvent,
        closeModal,
    };
}

// Reusable DeadlineModal component
export function DeadlineModal({ isOpen, event, deadline, onClose }) {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleLoginClick = () => {
        onClose();
        navigate('/login');
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-8 max-w-md mx-4 text-center shadow-2xl">
                <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
                    <svg className="w-8 h-8 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                        <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M12 9v4" />
                    </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Registration Deadline Reached</h3>
                <p className="text-gray-600 mb-6">
                    The registration deadline for <strong>{event?.title}</strong> has been reached. You can no longer submit applications for this event.
                </p>
                <div className="text-sm text-gray-500 mb-6">
                    Deadline was: <strong>{deadline ? deadline : "--"}</strong>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={handleLoginClick}
                        className="w-full py-3 px-6 bg-custom-blue-1 hover:bg-custom-blue-1/90 text-white font-semibold rounded-lg transition-colors"
                    >
                        Login
                    </button>
                </div>
            </div>
        </div>
    );
}

export default useDeadlineModal;
